import { BaseSerializer } from '@core/serializers/baseSerializer';

class DishSerializer extends BaseSerializer {
  // ============================================
  // DESERIALIZE: API -> UI
  // ============================================

  /**
   * Deserialize dish list response from API
   */
  deserializeList(raw) {
    const apiData = raw?.data;
    if (!apiData) {
      return [];
    }

    const dishes = apiData?.data || apiData || [];
    return dishes.map(dish => this.deserializeDish(dish));
  }

  /**
   * Deserialize single dish from API
   */
  deserializeDish(apiData) {
    if (!apiData) return null;

    // Default mapping, mapping API fields to what Vue components expect
    return {
      id: apiData.id || apiData._id,
      title: apiData.name || apiData.title,
      name: apiData.name || apiData.title,
      description: apiData.description || '',
      price: apiData.price || 0,
      currency: apiData.currency || 'XOF',
      
      // Category
      category: apiData.category,
      categoryId: apiData.categoryId,
      
      // Media
      principalImageUrl: apiData.principalImageUrl || apiData.image,
      images: apiData.images || [],

      // Status
      isPublished: apiData.isPublished !== undefined ? apiData.isPublished : true,
      isFeatured: apiData.isFeatured || false,
      isTopSeller: apiData.isTopSeller || false,

      // Restaurant
      restaurantId: apiData.restaurantId || apiData.restaurant?.id,
      storeId: apiData.restaurantId || apiData.restaurant?.id,
      storeName: apiData.restaurant?.name?.name || apiData.restaurant?.name || apiData.restaurantName || 'Restaurant',
      restaurant: apiData.restaurant ? {
        id: apiData.restaurant.id,
        name: apiData.restaurant.name,
        city: apiData.restaurant.city
      } : null,

      // Extra fields used by frontend (may not be in basic API schema)
      promotion: apiData.promotion || null,
      options: apiData.options || [],
      accompaniments: (apiData.accompaniments || []).map(acc => ({
        id: acc.id || acc._id,
        name: acc.name,
        price: acc.price || 0,
        amount: acc.amount || acc.price || 0,
        description: acc.description || ''
      })),
      cookDurationInMin: apiData.cookDurationInMin || 15, // Default fallback
      
      // Helpers
      isRestaurantOpen: apiData.restaurant?.isOpen !== false,
      canOrder: apiData.isPublished !== false && apiData.restaurant?.isOpen !== false,

      // Timestamps
      createdAt: apiData.createdAt,
      updatedAt: apiData.updatedAt,
      
      // Raw data
      raw: apiData
    };
  }

  /**
   * Deserialize error response from API
   */
  deserializeError(apiError) {
    if (!apiError) {
      return {
        message: 'Une erreur est survenue',
        code: 'UNKNOWN_ERROR'
      };
    }

    return {
      message:
        apiError.message ||
        apiError.data?.message ||
        apiError.error?.message ||
        'Une erreur est survenue',
      code:
        apiError.code ||
        apiError.data?.code ||
        apiError.error?.code ||
        'API_ERROR'
    };
  }
}

// Export singleton instance
const dishSerializer = new DishSerializer();
export default dishSerializer;
